<div class="card">
  <modal-product-packs
    [pack]="newPack"
    [productId]="productDetailService.product?.id"
    [(loading)]="productDetailService.loading"
    (reloadProduct)="productDetailService.refreshProduct()"
    [isCreating]="true"
    [dataCyAttribute]="'modal-product-packs-create'"
  >
  </modal-product-packs>
  @if (productDetailService.product.packs?.length > 0) {
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>
              {{ 'code' | translate }}
            </th>
            <th>
              {{ 'ean' | translate }}
            </th>
            <th class="text-center">
              {{ 'quantity' | translate }}
            </th>
            <th class="text-end">
              {{ 'weight' | translate }}
            </th>
            <th class="text-end">
              {{ 'note' | translate }}
            </th>
            <th class="text-center">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (pack of productDetailService.product.packs; track pack) {
            <tr>
              <td>
                {{ pack?.code }}
              </td>
              <td>
                {{ pack?.ean }}
              </td>
              <td class="text-center">
                {{ pack?.quantity }}
              </td>
              <td class="text-end">
                <span>
                  {{ pack?.weight > 0 ? pack?.weight + '&nbsp;' + 'kg' : '' }}
                </span>
              </td>
              <td class="text-end">
                {{ pack?.note }}
              </td>
              <td class="text-center">
                <modal-product-packs
                  [pack]="pack"
                  [productId]="productDetailService.product?.id"
                  [isCreating]="false"
                  [(loading)]="productDetailService.loading"
                  (reloadProduct)="productDetailService.refreshProduct()"
                  [dataCyAttribute]="'modal-product-packs-edit'"
                >
                </modal-product-packs>
                <btn [icon]="'fa-qrcode'" (onEvent)="printPackQR(pack)"></btn>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
